import React from 'react';
import { Container, Grid, Typography, Box  } from '@mui/material';

const EVENT_NAME = 'Assemblea Generale 2026'
// const EVENT_DATE = 'VENERDI 1 MARZO ORE 17.00'
// const EVENT_DATE = 'VENERDI 28 FEBBRAIO ORE 16.45'
const EVENT_DATE = [ 'VENERDI 27 FEBBRAIO', 'ORE 17.30' ]
const EVENT_LOCATION = 'SALA DISPLAY - BRIXIA FORUM'

const Header = () => {
  return (
    <>
        <Container maxWidth="sm">
        {/* Apply the background color to the Container or a Box within it */}
            <Box sx={{padding: 2,  backgroundColor:  'rgb(13, 95, 49)', color: 'white', borderRadius: '8px', padding: 2 }}>
                <Grid container spacing={2} alignItems="center">
                <Grid item xs={6}>
                    <Typography variant="h5" component="h1" textAlign="center">
                        {EVENT_NAME}
                    </Typography>
                    <Box sx={{ width: '100%', height: '5px', marginTop: 1, backgroundImage: 'linear-gradient(to right, green 33%, white 33%, white 66%, red 66%)' }} />
                </Grid>
                <Grid item xs={6}>
                    { EVENT_DATE.map(row => (
                        <Typography variant="body1" component="p" textAlign="center" fontWeight="bold">
                            {row}
                        </Typography>
                    )) }
                    <Typography variant="body2" component="p" textAlign="center">
                        {EVENT_LOCATION}
                    </Typography>
                </Grid>
                </Grid>
            </Box>
        </Container>

        {/* Text Box Section */}
        <Container maxWidth="sm" sx={{ mt: 2 }}>
            <Box sx={{ borderTop: 10, borderColor: 'rgb(13, 95, 49)' , backgroundColor: 'white', borderRadius: '8px' , padding: 2 ,marginBottom: 2 }}>
                <Typography variant="h4" component="p" sx={{ mt: 2, fontWeight: 'bold' }}>
                REGISTRAZIONE PRESENZE
                </Typography>
                <Typography variant="h6" component="p" sx={{ mt: 2 }}>
                    {EVENT_NAME.toUpperCase()}
                </Typography>
                {/* <Typography variant="body1" component="p" sx={{ mt: 2 }}>
                Compila il modulo per registrare la tua presenza all'Assemblea 2024 di Confagricoltura Brescia.
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body2" component="p" sx={{ mb: 2 }}>
                * Indica una domanda obbligatoria
                </Typography> */}
            </Box>
        </Container>
    </>
  );
};

export default Header;
